import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';
import {
  appRoutePaths,
  importComponentRoutePath,
} from '../../components/Root/navigation';

const catalogImportRouteRef = createRouteRef({
  aliasFor: 'catalog-import.importPage',
});

const catalogImportPage = PageBlueprint.make({
  name: 'driveline-import',
  params: {
    path: appRoutePaths.import,
    routeRef: catalogImportRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/importpage/CustomCatalogImportPage').then(
        module => <module.CatalogImportPageWithPermission />,
      ),
  },
});

const legacyCreateTemplatesRedirectPage = PageBlueprint.make({
  name: 'driveline-legacy-create-templates-redirect',
  params: {
    path: '/create/templates',
    noHeader: true,
    loader: async () => <Navigate replace to={importComponentRoutePath} />,
  },
});

export const catalogImportPageModule = createFrontendModule({
  pluginId: 'catalog-import',
  extensions: [catalogImportPage, legacyCreateTemplatesRedirectPage],
});
